import React from 'react';

export interface WrapperProps {
  children: React.ReactElement;
  theme: {
    [key: string]: string;
  };
}

const ThemeProvider: React.FC<WrapperProps> = ({
  children,
  theme
}: WrapperProps) => <div style={theme}>{children}</div>;

export default ThemeProvider;
